module.exports = __webpack_public_path__ + "static/media/img-heritage-area3-nirayamaHansharo.4c716e27.jpg";